export default __webpack_public_path__ + "static/media/CVD.b9edf806.png";